/**
 * Cờ bật/tắt tính năng phía FE (build-time, Vite env).
 *
 * `VITE_SIGNUP_ENABLED` (2026-10-03): tự đăng ký tài khoản — mặc định TẮT; tài khoản
 * do quản trị trường tạo/mời. Set `VITE_SIGNUP_ENABLED=true` để hiện lại các nút
 * "Tạo tài khoản mới" / "Đăng ký".
 */
export const SIGNUP_ENABLED = import.meta.env.VITE_SIGNUP_ENABLED === "true";
